import type { ColDef } from "ag-grid-community";

const formatPercent = (value: number | null | undefined) =>
	value === null || value === undefined
		? ""
		: `${value.toLocaleString("en-US", { maximumFractionDigits: 2 })}%`;

export const useTableData = () => {
	const columnDefs: ColDef[] = [
		{
			field: "TargetName",
			headerName: "Target",
			flex: 2,
			minWidth: 180,
		},
		{
			field: "TargetCode",
			headerName: "Code",
			flex: 1,
			minWidth: 120,
		},
		{
			field: "AssetName",
			headerName: "Asset",
			flex: 1,
			minWidth: 130,
			valueFormatter: (params) => params.value ?? "—",
		},
		{
			field: "DefaultAllocationPercent",
			headerName: "Default %",
			flex: 1,
			minWidth: 120,
			type: "rightAligned",
			valueFormatter: (params) =>
				params.value === null ? "Not set" : formatPercent(params.value),
		},
		{
			field: "DisplayOrder",
			headerName: "Order",
			flex: 1,
			maxWidth: 100,
			type: "rightAligned",
		},
	];

	return { columnDefs };
};
